<template>
  <div class="menu-item-aggregators-settings">
    <fields-group label="Настройки выгрузки в агрегаторы (устарело)">
      <v-switch
        label="Выгружать в агрегаторы"
        color="primary"
        :input-value="aggregatorStatus"
        :loading="loading"
        :disabled="loading"
        @change="(val) => $emit('update:aggregatorStatus', val)"
      />
      <transition name="slide">
        <div v-show="aggregatorStatus" class="menu-item-aggregators-settings_fields">
          <upload-image
            :img="aggregatorImage"
            color="orange"
            label="Другое изображение в агрегаторах"
            @input="(val) => $emit('update:aggregatorImage', val)"
          >
            Загрузить
          </upload-image>

          <v-text-field
            type="number"
            :value="aggregatorPriceRate"
            label="Коэффициент цены для агрегаторов"
            placeholder="1"
            outlined
            :loading="loading"
            :disabled="loading"
            @input="(val) => $emit('update:aggregatorPriceRate', val)"
          />
        </div>
      </transition>
    </fields-group>
  </div>
</template>

<script>
  import FieldsGroup from '@/components/ui/FieldsGroup.vue'
  import UploadImage from '@/components/UploadImage.vue'

  export default {
    name: 'MenuItemAggregatorsSettings',
    components: { UploadImage, FieldsGroup },
    props: {
      aggregatorPriceRate: {
        type: [Number, String],
        default: null,
      },
      aggregatorImage: {
        type: String,
        default: null,
      },
      aggregatorStatus: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="less">
.menu-item-aggregators-settings {
  &_fields {
    padding-top: 30px;
  }
}
</style>
